"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Checkbox_1 = require("../Input/Checkbox");
function Checkbox(props) {
    return jsx_runtime_1.jsx(Checkbox_1.Checkbox, Object.assign({ type: "checkbox" }, props), void 0);
}
exports.Checkbox = Checkbox;
//# sourceMappingURL=index.js.map